<template>
  <div class="ps-rounded-full ps-overflow-hidden">
    <img v-if="user.avatar" class="" :src="user.avatar" />
    <div
      v-else
      :class="[color]"
      class="ps-w-full ps-h-full ps-flex ps-items-center ps-justify-center"
    >
      <svg-icon name="user-circle" width="100%" height="auto" />
    </div>
  </div>
</template>

<script>
import '@/icons/user-circle'

export default {
  name: 'UserAvatar',
  props: {
    user: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: 'ps-text-white'
    }
  }
}
</script>
